import { render } from "./SetupCenter.vue?vue&type=template&id=e1c6d38e"
import script from "./SetupCenter.vue?vue&type=script&lang=js"
export * from "./SetupCenter.vue?vue&type=script&lang=js"

import "./SetupCenter.vue?vue&type=style&index=0&id=e1c6d38e&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__